import { gql } from "@apollo/client";

export const ADDRESSES = gql`
  query Addresses($where: AddressWhereInput, $skip: Int, $take: Int) {
    addresses(where: $where, skip: $skip, take: $take) {
      data {
        id
        value
        type
        chain
        token {
          id
          name
          address
          type
          enabled
          balances {
            id
            value
          }
        }
      }
      count
    }
  }
`;

export const ADDRESS = gql`
  query Address($where: AddressWhereInput) {
    address(where: $where) {
      id
      value
      token {
        id
        name
        address
        type
        enabled
        balances {
          id
          value
        }
      }
    }
  }
`;

const address = { ADDRESSES, ADDRESS };

export default address;
